import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core'
import { OrderSideEnum } from '@modules/orders-module/enums/order-side.enum'
import { OrderInterface } from '@modules/orders-module/interfaces/order.interface'
import { TranslatePipe } from '@ngx-translate/core'
import { OrderStatusEnum } from '@modules/orders-module/enums/order-status.enum'
import { HighlightDirective } from '@shared/directives/higlight.directive'
import { DatePipe } from '@angular/common'
import { OrderTypeEnum } from '@modules/orders-module/enums/order-type.enum'
import { FilledOrderStatuses } from '@modules/orders-module/constants/filled-order-statuses'
import { CancelOrderStatuses } from '@modules/orders-module/constants/cancel-order-statuses'
import { ClipboardDirective } from '@shared/directives/clipboard/clipboard.directive'
import { TitleOrderTypePipe } from '@modules/orders-module/pipes/title-order-type.pipe'
import { TuiIcon } from '@taiga-ui/core'
import { TitleOrderTermPipe } from '@modules/orders-module/pipes/title-order-term.pipe'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { PricePipe } from '@shared/pipes/price.pipe'
import { ProfitPipe } from '@shared/pipes/profit.pipe'
import { QuantityPipe } from '@shared/pipes/quantity.pipe'
import { PercentPipe } from '@shared/pipes/percent.pipe'

@UseLocales({ ru, en })
@Component({
	selector: 'app-order-info-body-detailed',
	templateUrl: './order-info-body-detailed.component.html',
	styleUrl: './order-info-body-detailed.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		TranslatePipe,
		HighlightDirective,
		TitleOrderTypePipe,
		ClipboardDirective,
		TuiIcon,
		TitleOrderTermPipe,
		DatePipe,
		PricePipe,
		ProfitPipe,
		QuantityPipe,
		PercentPipe,
	],
})
export class OrderInfoBodyDetailedComponent {
	protected readonly orderSideEnum: typeof OrderSideEnum = OrderSideEnum
	protected readonly orderTypeEnum: typeof OrderTypeEnum = OrderTypeEnum
	protected readonly filledOrderStatuses: OrderStatusEnum[] = FilledOrderStatuses
	protected readonly cancelOrderStatuses: OrderStatusEnum[] = CancelOrderStatuses

	public order: InputSignal<OrderInterface | null> = input<OrderInterface | null>(null)

	get isOrderFilled(): boolean {
		const order: OrderInterface | null = this.order()
		if (!order) return false

		return this.filledOrderStatuses.includes(order.status)
	}

	get isOrderCanceled(): boolean {
		const order: OrderInterface | null = this.order()
		if (!order) return false

		return this.cancelOrderStatuses.includes(order.status)
	}
}
